require(".").check("es5");